import * as types from "../Actions/Types";
import { IStore, IUserPreferences } from "../Models/Models";
import { GET_USER_PREFERENCES_SUCCESS_SCOUT } from "../Actions/Types";

export interface IUserPreferencesStore {
  userPreferences: IUserPreferences;
  communitySites: Array<IStore>;
}
export const defaultState: IUserPreferencesStore = {
    userPreferences: null,
    communitySites: [],
};

export const userPreferencesStore = (
    userPreferencesStore: IUserPreferencesStore = { ...defaultState },
    action
) => {
    switch (action.type) {
        case types.GET_USER_PREFERENCES_SUCCESS: {
            return Object.assign({}, userPreferencesStore, {
                userPreferences: action.response.data,
            });
        }

        case GET_USER_PREFERENCES_SUCCESS_SCOUT: {
            return {
                ...userPreferencesStore,
                userPreferences: action.data,
            };
        }

        case types.UPDATE_USER_PREFERENCES_SUCCESS: {
            // update SCOUT
            (window as any).scout.logic.UserPreferencesLogic.userPreferences
        = action.response.data;

            return Object.assign({}, userPreferencesStore, {
                userPreferences: action.response.data,
            });
        }

        case types.GET_ALL_COMMUNITY_SITES_SUCCESS:
            return Object.assign({}, userPreferencesStore, {
                communitySites: action.response.data || [],
            });

        case types.GET_USER_PREFERENCES_FAILURE:
        case types.UPDATE_USER_PREFERENCES_FAILURE:
        case types.GET_ALL_COMMUNITY_SITES_FAILURE:
            console.log(action);
            return userPreferencesStore;

        default:
            return userPreferencesStore;
    }
};
